import React from "react";
import {
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table,
} from '@material-ui/core';
import moment from 'moment';
import Paper from '@material-ui/core/Paper';

export default class ComponentToPrint extends React.Component {
  render() {
    const APRemovalDetailListData = this.props.APRemovalDetailListData;
    const selectedSearchValues = this.props.selectedSearchValues;

    const cellStyle = {
      border: '1px solid black',
      padding: '1px',
      fontSize: '0.9rem',
    };

    return (
      <Paper elevation={0} style={{ width: '100%', height: '100%', paddingLeft: '5px', paddingRight: '5px' }}>
        <div>
          <h3><center><u>Advance Payments Removal Report</u></center></h3>
          <h4><center>{selectedSearchValues.groupName} - {selectedSearchValues.factoryName}</center></h4>
          <h5><center>Frome Date: {moment(selectedSearchValues.fromDate).format('YYYY/MM/DD')} - To Date : {moment(selectedSearchValues.toDate).format('YYYY/MM/DD')}</center></h5>
          <div>&nbsp;</div>
          <div >
            <Box sx={{ minWidth: 1050 }}>
              <TableContainer>
                <Table aria-label="caption table">
                  <TableHead>
                    <TableRow style={{ border: '1px solid black' }}>
                      <TableCell align={'left'} style={cellStyle}>Issuing Date</TableCell>
                      <TableCell align={'left'} style={cellStyle}>Removed Date</TableCell>
                      <TableCell align={'left'} style={cellStyle}>Route Name</TableCell>
                      <TableCell align={'center'} style={cellStyle}>Registration Number</TableCell>
                      <TableCell align={'center'} style={cellStyle}>Amount</TableCell>
                      <TableCell align={'left'} style={cellStyle}>Source</TableCell>
                      <TableCell align={'left'} style={cellStyle}>Removed By</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {APRemovalDetailListData.map((data, index) => (
                      <TableRow key={index} style={{ border: '1px solid black' }}>
                        <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                          {data.issuingDate != null ? (moment(data.issuingDate).format('YYYY/MM/DD')) : null}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                          {data.modifiedDate != null ? (moment(data.modifiedDate).format('YYYY/MM/DD')) : null}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                          {data.routeName}
                        </TableCell>
                        <TableCell align={'center'} component="th" scope="row" style={cellStyle}>
                          {data.registrationNumber}
                        </TableCell>
                        <TableCell align="right" component="th" scope="row" style={cellStyle}>
                          {data.approvedAmount ? data.approvedAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })  : '0.00'}
                        </TableCell>
                        <TableCell align="left" component="th" scope="row" style={cellStyle}>
                          {data.advanceRequestType === 2
                            ? 'Over Advanced'
                            : data.advanceRequestType === 3
                              ? 'Direct Advanced'
                              : data.advanceRequestType}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                          {data.userName}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </div>
          <div>&nbsp;</div>
          <h4><center>*******End of List*******</center></h4>
        </div>
      </Paper>
    );
  }

}
